import * as Dashboard from './dashboard';
import * as SensorsAndConnectors from './sensors-and-connectors';
import * as FoldersAndLabels from './folders-and-labels';
import * as UsersAndAccess from './users-and-access';
import * as DeveloperSettings from './developer-settings';
import * as AlertsActions from './alerts-actions';
import * as AccountSettings from './account-settings';
import * as CompanySettings from './company-settings';

import * as Notifications from './notifications';

export {
    Dashboard,
    SensorsAndConnectors,
    FoldersAndLabels,
    UsersAndAccess,
    DeveloperSettings,
    AlertsActions,
    AccountSettings,
    CompanySettings,

    Notifications
};



// WEBPACK FOOTER //
// ./app/components/index.js